import './GettingStartedOverview.scss';
import { Box } from '@mui/material';
import { useMemo } from 'react';
import Banner from '../../../components/GettingStarted/Banner/Banner';
import Steps from '../../../components/GettingStarted/Steps/Steps';
import { useTranslation } from 'react-i18next';

const GettingStartedOverview = ({ navOpen }) => {
  const { t } = useTranslation();
  const gettingStarted = useMemo(
    () => t('ndc-program.gettingstarted', { returnObjects: true, defaultValue:[] }),
    [t]
  );

  return (
    <Box className="getting-started-container">
      <style>{`.apiBodyHeaderBG { display: none !important; }`}</style>
      <Banner
        data={gettingStarted?.['section.banner']}
        description={t('getting_started_description', { returnObjects: true })}
      />
      <Steps
        data={gettingStarted?.['section.step']}
        navOpen={navOpen}
        drupalData={t('getting_started_quick_links', { returnObjects: true })}
        drupalData1={t('getting_started_boxes', { returnObjects: true })}
      />
    </Box>
  );
};

export default GettingStartedOverview;
